// API Configuration
export const API_URL = import.meta.env.VITE_API_APP_URL || 'https://api.dev.newsne.ws'
export const SOCKET_URL = import.meta.env.VITE_API_SOCKET_URL || 'wss://api.dev.newsne.ws'

// CSS Gradient placeholders (no external image loading)
export const GRADIENT_PLACEHOLDERS = [
  'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
  'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
  'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
  'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
  'linear-gradient(135deg, #ff6e7f 0%, #bfe9ff 100%)',
]

// Helper function to get random gradient placeholder
export function getRandomGradient() {
  const randomIndex = Math.floor(Math.random() * GRADIENT_PLACEHOLDERS.length)
  return GRADIENT_PLACEHOLDERS[randomIndex]
}

// Helper function to get consistent gradient based on string (for same article always same gradient)
export function getGradientForId(id) {
  if (!id) return getRandomGradient()
  const hash = id.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc)
  }, 0)
  const index = Math.abs(hash) % GRADIENT_PLACEHOLDERS.length
  return GRADIENT_PLACEHOLDERS[index]
}

// Backward compatibility
export function getRandomImage() {
  return null // Return null to trigger CSS gradient fallback
}

// Pagination
export const ITEMS_PER_PAGE = 20

// Local storage keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
  VIEW_MODE: 'view_mode', // 'card' or 'list'
  THEME: 'theme', // 'light' or 'dark'
}
